/**
 * Created by fers on 24/04/2017.
 */

import types from '../../common/model-api/types';
import urlMapping from '../app/URLMapping';
import ChannelOptionEdit from './ChannelOptionEdit.react';
import ChannelAddStep3 from './ChannelAddStep3.react';
import ChannelAddStep4 from './ChannelAddStep4.react';
import ChannelAddStep5 from './ChannelAddStep5.react';
import {
    CHANNEL_CREATE_STEP_FINISH,
    CHANNEL_CREATE_STEP_GRANT,
    CHANNEL_CREATE_STEP_OPTIONS,
    CHANNEL_CREATE_STEP_POST_GRANT,
    getFirstChannelCreateStep,
} from './channelCreateSteps';

// eslint-disable-next-line max-params
export function getUrlForChannelCreate(organisation, channel, channelDef, scenario) {
    let args = {
        id: channel['id'],
        organisation_id: organisation['realId']
    };

    /* are we creating this channel as part of scenario? */
    let scenarioPrefix = "";
    if (scenario) {
        args['scenario_id'] = scenario['realId'];
        scenarioPrefix = "scenario-";
    }

    switch (getFirstChannelCreateStep(channelDef)) {
        case CHANNEL_CREATE_STEP_OPTIONS:
            return urlMapping.getUrl(types['channels'], scenarioPrefix + "create-step-2", args);
        case CHANNEL_CREATE_STEP_GRANT:
            return urlMapping.getUrl(types['channels'], scenarioPrefix + "create-step-3", args);
        case CHANNEL_CREATE_STEP_POST_GRANT:
            return urlMapping.getUrl(types['channels'], scenarioPrefix + "create-step-4", args);
        case CHANNEL_CREATE_STEP_FINISH:
        default:
            return urlMapping.getUrl(types['channels'], scenarioPrefix + "create-step-5", args);
    }
}

export function getComponentForChannelCreate(channelDef) {
	switch (getFirstChannelCreateStep(channelDef)) {
		case CHANNEL_CREATE_STEP_OPTIONS:
			return ChannelOptionEdit;
		case CHANNEL_CREATE_STEP_GRANT:
			return ChannelAddStep3;
		case CHANNEL_CREATE_STEP_POST_GRANT:
			return ChannelAddStep4;
		case CHANNEL_CREATE_STEP_FINISH:
		default:
			return ChannelAddStep5;
	}
}
